import { render, staticRenderFns } from "./travelColumn.vue?vue&type=template&id=4d55ba6c&scoped=true&"
import script from "./travelColumn.vue?vue&type=script&setup=true&lang=js&"
export * from "./travelColumn.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./travelColumn.vue?vue&type=style&index=0&id=4d55ba6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d55ba6c",
  null
  
)

export default component.exports